import React, { Component } from "react";
import { SideBar, NavBar, TitleAndDescription, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import axios from "axios";
import queryString from "query-string";
require("dotenv").config();

export default class PedidoInfo extends Component {
  constructor(props) {
    super(props);
    this.loadPedidoStorage = this.loadPedidoStorage.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.notificar = this.notificar.bind(this);
    this.getDefaultPedido = this.getDefaultPedido.bind(this);
    this.salvarPedidoLocalStorage = this.salvarPedidoLocalStorage.bind(this);
    this.abrirPaginaAdicionarEndereco =
      this.abrirPaginaAdicionarEndereco.bind(this);
    this.abrirPaginaCarrinho = this.abrirPaginaCarrinho.bind(this);
    this.abrirPaginasEtapa = this.abrirPaginasEtapa.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);

    this.state = {
      idPedido: null,
      actionPage: "CADASTRAR",
      clientes: [],
      pedido: this.getDefaultPedido(),
      contatos: [],
      enderecos: [],
      db: null,
    };
  }

  async componentDidMount() {
    this.verificaAutenticacao();
    let idPedido = queryString.parse(this.props.location.search).id;
    let actionPage = this.state.actionPage;

    if (idPedido !== undefined) {
      actionPage = "EDITAR";
    }

    this.setState(
      {
        actionPage,
        idPedido,
      },
      async () => {
        await this.loadPedidoStorage();
        localStorage.setItem("lastPage", "pedidoInfo");
      }
    );
  }

  getDefaultPedido() {
    return {
      tipoPedido: null,
      cliente: null,
      condPagto: null,
      formaPagto: null,
      transportadora: null,
      label: {},
      itens: [],
      contato: null,
      endereco: {
        endereco: "",
        bairro: "",
        cidade: "",
        uf: "",
      },
      observacao: "",
      previsaoEntrega: new Date(),
      ordemCompra: "",
    };
  }

  async loadPedidoStorage() {
    let pedidoStorage = null;

    if (this.state.actionPage === "CADASTRAR") {
      pedidoStorage = localStorage.getItem("pedido");
    } else if (this.state.actionPage === "EDITAR") {
      pedidoStorage = localStorage.getItem("orcamento");
    }

    if (pedidoStorage !== null) {
      pedidoStorage = JSON.parse(pedidoStorage);

      let label = pedidoStorage.cliente.label;
      pedidoStorage.cliente.label = pedidoStorage.cliente.descFormat;
      pedidoStorage.previsaoEntrega = new Date(pedidoStorage.previsaoEntrega);

      let clientes = [];

      let clienteStorage = pedidoStorage.cliente;

      if (clienteStorage.tipoPessoa === undefined) {
        let cnpjCpf = clienteStorage.cnpjCpf;
        cnpjCpf = cnpjCpf.replace(/\D/g, "");

        if (cnpjCpf.length > 11) {
          clienteStorage.tipoPessoa = "PJ";
        } else {
          clienteStorage.tipoPessoa = "PJ";
        }
      }

      clientes.push(clienteStorage);

      let enderecos = pedidoStorage.cliente.enderecos;

      enderecos = enderecos.map((endereco) => {
        endereco.value = endereco.endereco;
        endereco.label = `${endereco.endereco}, ${endereco.numero}`;
        return endereco;
      });

      this.setState({
        pedido: pedidoStorage,
        label: label,
        clientes,
        contatos: pedidoStorage.cliente.contatos,
        enderecos: enderecos,
      });
    } else {
      this.props.history.push("/home");
    }
  }

  async handleChangeSelect(item, tipo) {
    this.setState({ pedido: { ...this.state.pedido, [tipo]: item } }, () => {
      this.salvarPedidoLocalStorage(this.state.pedido);
    });
  }

  handleChangeInput(e, tipo) {
    this.setState(
      { pedido: { ...this.state.pedido, [tipo]: e.target.value } },
      () => {
        this.salvarPedidoLocalStorage(this.state.pedido);
      }
    );
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  salvarPedidoLocalStorage(pedido) {
    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(pedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(pedido));
    }
  }

  abrirPaginaAdicionarEndereco() {
    localStorage.setItem("urlAnterior", this.props.history.location.pathname);
    localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    this.props.history.push(
      `/enderecos-editar?id=${this.state.pedido.cliente._id}`
    );
  }

  abrirPaginaCarrinho() {
    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
    }
    let url = "/carrinho";
    if (this.state.actionPage === "EDITAR") {
      url = url + `?id=${this.state.idPedido}`;
    }
    this.props.history.push(url);
  }

  abrirPaginasEtapa(pagina) {
    if (pagina !== "pedido" && this.state.pedido.cliente === null) {
      this.notificar("warning", "Selecione o cliente para continuar!");
      return false;
    }

    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
    }

    let url = "";

    if (pagina === "pedido") {
      url = "/pedidos-novo";
    } else if (pagina === "pedidoInfo") {
      url = "/pedidos-novo-info";
    } else if (pagina === "carrinho") {
      url = "/carrinho";
    } else if (pagina === "revisao") {
      url = "/pedidos-revisao";
    }
    if (this.state.actionPage === "EDITAR") {
      url = url + `?id=${this.state.idPedido}`;
    }
    this.props.history.push(url);
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao-pedidos`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title={`Info do ${this.state.actionPage === "CADASTRAR" ? 'Pedido' : 'Orçamento'}`} />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"novoPedido"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title={`Cadastrar Pedido`}
                  description="Adicionar um novo pedido"
                /> */}

                <div>
                  <ul
                    id="alterUl"
                    className="nav nav-tabs justify-content-center process-model more-icon-preocess"
                    role="tablist"
                  >
                    <li
                      id="li-cliente"
                      role="presentation"
                      className="visited"
                      onClick={() => {
                        this.abrirPaginasEtapa("pedido");
                      }}
                    >
                      <a aria-controls="discover" role="tab" data-toggle="tab">
                        <i className="fa fa-plus" aria-hidden="true"></i>
                        <p>Pedido</p>
                      </a>
                    </li>

                    <li id="li-info" role="presentation" className="active">
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                        <p>Info adicionais</p>
                      </a>
                    </li>
                    <li
                      id="li-info"
                      role="presentation"
                      onClick={() => {
                        this.abrirPaginasEtapa("carrinho");
                      }}
                    >
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i
                          className="fa fa-shopping-cart"
                          aria-hidden="true"
                        ></i>
                        <p>Itens</p>
                      </a>
                    </li>
                    <li
                      id="li-info"
                      role="presentation"
                      onClick={() => {
                        this.abrirPaginasEtapa("revisao");
                      }}
                    >
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i className="fa fa-edit" aria-hidden="true"></i>
                        <p>Revisão</p>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className="row"
                                  style={{ padding: "10px" }}
                                >
                                  {this.state.clientes.length > 0 &&
                                    this.state.clientes[0].tipoPessoa ===
                                      "PJ" && (
                                      <div className="col-md-5 pd-pedido">
                                        <div className="form-group">
                                          <label>Contato</label>
                                          <Select
                                            options={this.state.contatos}
                                            value={this.state.pedido.contato}
                                            onChange={(item) =>
                                              this.handleChangeSelect(
                                                item,
                                                "contato"
                                              )
                                            }
                                            placeholder="Selecione"
                                            isDisabled={
                                              this.state.clientes.length > 0 &&
                                              this.state.clientes[0]
                                                .tipoPessoa === "PF"
                                                ? true
                                                : false
                                            }
                                          />
                                        </div>
                                      </div>
                                    )}

                                  <div className="col-md-5 pd-pedido">
                                    <div
                                      className="form-group"
                                      style={{ position: "relative" }}
                                    >
                                      <label>Endereço de entrega</label>
                                      <span
                                        style={{
                                          fontSize: "22px",
                                          paddingLeft: "5px",
                                          cursor: "pointer",
                                          color: "#888",
                                          position: "absolute",
                                        }}
                                        onClick={
                                          this.abrirPaginaAdicionarEndereco
                                        }
                                      >
                                        <i
                                          className="fa fa-map-marker"
                                          aria-hidden="true"
                                          style={{
                                            color: "#5f9f1a",
                                            position: "relative",
                                            top: "-3px",
                                          }}
                                        ></i>
                                      </span>

                                      <Select
                                        options={this.state.enderecos}
                                        value={this.state.pedido.endereco}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "endereco"
                                          )
                                        }
                                        placeholder="Selecione"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label>CEP</label>
                                      <input
                                        type="text"
                                        className="form-control font-size-13"
                                        value={this.state.pedido.endereco.cep}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3 pd-pedido">
                                    <div className="form-group">
                                      <label>Bairro</label>
                                      <input
                                        type="text"
                                        className="form-control font-size-13"
                                        value={
                                          this.state.pedido.endereco.bairro
                                        }
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-5 pd-pedido">
                                    <div className="form-group">
                                      <label>Cidade</label>
                                      <input
                                        type="text"
                                        className="form-control font-size-13"
                                        value={`${this.state.pedido.endereco.cidade} - ${this.state.pedido.endereco.estado}`}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label>Previsão de entrega</label>
                                      <DatePicker
                                        selected={
                                          this.state.pedido.previsaoEntrega
                                        }
                                        withPortal
                                        customInput={
                                          <input className="form-control font-size-13" />
                                        }
                                        dateFormat="dd/MM/yyyy"
                                        onChange={(date) => {
                                          this.setState(
                                            {
                                              pedido: {
                                                ...this.state.pedido,
                                                previsaoEntrega: date,
                                              },
                                            },
                                            () => {
                                              this.salvarPedidoLocalStorage(
                                                this.state.pedido
                                              );
                                            }
                                          );
                                        }}
                                        locale="pt-BR"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label>Ordem de Compra</label>
                                      <input
                                        type="text"
                                        className="form-control font-size-13"
                                        rows="3"
                                        value={this.state.pedido.ordemCompra}
                                        onChange={(e) =>
                                          this.handleChangeInput(
                                            e,
                                            "ordemCompra"
                                          )
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-12 pd-pedido">
                                    <div className="form-group">
                                      <label>Observação do pedido</label>
                                      <textarea
                                        className="form-control"
                                        rows="3"
                                        value={this.state.pedido.observacao}
                                        onChange={(e) =>
                                          this.handleChangeInput(
                                            e,
                                            "observacao"
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-12 pd-pedido">
                                    <div className="form-group">
                                      <button
                                        className="btn btn-success"
                                        onClick={this.abrirPaginaCarrinho}
                                      >
                                        Próximo
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
